/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PayMethodEnum {
  CARD = "card",
  SBP = "sbp",
}
